import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-page04',
  templateUrl: './blog-page04.component.html',
  styleUrls: ['./blog-page04.component.css']
})
export class BlogPage04Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
